import { render, staticRenderFns } from "./IlgiliKisiButon.vue?vue&type=template&id=86a0e44e&"
import script from "./IlgiliKisiButon.vue?vue&type=script&lang=js&"
export * from "./IlgiliKisiButon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports